import { createFileRoute, Outlet } from "@tanstack/react-router";
import { validateCosmeticSearch } from "./-search-params";

/**
 * Pathless layout route for cosmetic/self-assessment screens.
 * Groups: self-front-cosmetics, self-back-cosmetics, etc.
 */
export const Route = createFileRoute("/$locale/$partner/_cosmetic")({
	validateSearch: validateCosmeticSearch,
	component: CosmeticLayout,
});

function CosmeticLayout() {
	return <Outlet />;
}
